<template id="vue-gender">
  <TransitionWithText :text="this.transitionText" :fast="true">
    <div class="page-content no-button">
      <span class="title animated">What is your biological sex?</span>

      <div class="content">
        <button
          v-bind:class="{'active': gender === 'f'}"
          class="gender-option"
          @click="updateGender('f')"
          v-bind:disabled="disabled"
        >Female</button>
        <button
          v-bind:class="{'active': gender === 'm'}"
          class="gender-option"
          v-bind:disabled="disabled"
          @click="updateGender('m')"
        >Male</button>
      </div>
    </div>

    <div class="footer-container">
      <ProgressBar />
    </div>
  </TransitionWithText>
</template>

<script>
import TransitionWithText from '../../shared/components/TransitionWithText';
import ProgressBar from '../../shared/components/ProgressBar';
import Trackeable from '../../Trackeable';
import { navigateTo, ROUTE_NAMES } from '../router';
import ProgressFull from '../mixins/ProgressFull';

export default {
  name: 'gender',
  components: {
    ProgressBar,
    TransitionWithText
  },
  mixins: [Trackeable, ProgressFull],
  template: '#vue-gender',
  data: function() {
    return {
      transitionText: "Let's calculate your specific prize...",
      gender: this.$store.state.nyop.gender,
      disabled: null
    };
  },
  beforeCreate: function() {
    this.$store.commit('resetStore');
  },
  created: function() {
    this.disabled = null;
  },
  methods: {
    updateGender: function(newGender) {
      this.disabled = 'disabled';
      this.gender = newGender;
      this.$store.commit('updateGender', newGender);
      navigateTo(this.$router, ROUTE_NAMES.Height);
    }
  }
};
</script>
